export class InvalidCpfFormat extends Error {
  constructor() {
    super('Número de CPF Inválido')
    this.name = 'InvalidCpfFormat'
  }
}
